"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.EventItem = void 0;
var _react = _interopRequireDefault(require("react"));
var _DownloadLinkBox = _interopRequireDefault(require("../../DownloadLinkBox/DownloadLinkBox"));
var _TagsGroup = _interopRequireDefault(require("../../../TagsGroup/TagsGroup"));
var _DateFormatter = _interopRequireDefault(require("../../../../common/Formatters/DateFormatter"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.events {\n  max-width: 100%;\n  height: min-content; }\n  .events #sia-inform-events {\n    background-color: #fbf1ec;\n    border-top: 1px solid #d4d4d4; }\n  .events #sia-events {\n    background-color: #e9eff7; }\n  .events #external-events {\n    background-color: #ecf7f3; }\n\n@media (max-width: 42rem) {\n  .events {\n    width: 100%; } }\n";
  const fileName = "Events_Events";
  const element = document.querySelector("style[data-sass-component='Events_Events']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const parseDate = dateStr => {
  const [day, month, year] = dateStr.split('.');
  return new Date(`${year}-${month}-${day}`);
};
const getDateLocation = (event, newsletter_date) => {
  let date, location;
  if (event?.event_generic_location?.[0]?.name) {
    location = event.event_generic_location[0].name;
  }
  if (event?.date_times && event.date_times.length > 0) {
    date = event?.date_times?.[0]?.date || 'Unknown Date';
    location = event?.date_times?.[0].event_generic_location?.name;
    if (event.date_times.length > 1) {
      const newsletterDateObj = parseDate(newsletter_date);
      for (const dt of event.date_times) {
        const eventDateObj = parseDate(dt.date[0]);
        if (eventDateObj > newsletterDateObj) {
          date = dt.date || 'Unknown Date';
          location = dt.event_generic_location?.name;
          break;
        }
      }
    }
  }
  return {
    date,
    location
  };
};
const getTitle = (date, event, category) => {
  const event_title = event?.occurrence_event_code?.title ? event?.occurrence_event_code?.title : event.title;
  if (category.id === 'external-events') {
    return event.label;
  }
  if (category.id === 'sia-events') {
    return `${event_title}, ${_DateFormatter.default.format(date)}`;
  }
  if (category.id === 'sia-inform-events') {
    return `${event_title}, ${_DateFormatter.default.format(date)}`;
  }
  return event_title;
};
const getLink = (event, category, title, lang) => {
  const event_occurrence_code = event.title;
  if (category.id === 'external-events') {
    return {
      original_url: event.url,
      url: event.url,
      title
    };
  }
  if (event.evenito_link && event?.evenito_link?.original_url) {
    return {
      original_url: event.evenito_link?.original_url,
      title,
      url: event.evenito_link?.original_url
    };
  }
  return {
    original_url: `/${lang}/agenda/${event_occurrence_code}`,
    title
  };
};
const EventItem = _ref => {
  let {
    event,
    category,
    lang,
    newsletter_date
  } = _ref;
  const {
    date,
    location
  } = getDateLocation(event, newsletter_date);
  const title = getTitle(date, event, category);
  const links = [{
    link: getLink(event, category, title, lang)
  }];
  const locationTag = location ? [{
    label: location,
    type: 'tertiary'
  }] : [];
  const formatTag = event?.format?.name ? [{
    label: event?.format?.name,
    type: 'quaternary'
  }] : [];
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, links?.length > 0 && /*#__PURE__*/_react.default.createElement("div", {
    className: "container sia-margin-02-top "
  }, category.id === 'sia-events' ? /*#__PURE__*/_react.default.createElement("p", {
    className: "sia-text-08"
  }, title) : /*#__PURE__*/_react.default.createElement(_DownloadLinkBox.default, {
    items: links,
    lang: lang,
    isCMS: false
  }), (formatTag.length > 0 || locationTag > 0) && /*#__PURE__*/_react.default.createElement("div", {
    className: "tags sia-margin-01-top sia-padding-04-inline"
  }, /*#__PURE__*/_react.default.createElement(_TagsGroup.default, {
    items: [...formatTag, ...locationTag]
  }))));
};
exports.EventItem = EventItem;
const Events = _ref2 => {
  let {
    newsletter_date,
    event_labels,
    event_occurrences,
    sia_events,
    external_events,
    agenda_url,
    lang,
    removeAgendaLink
  } = _ref2;
  const eventCategories = [{
    id: 'sia-inform-events',
    title: event_labels['cms.newsletter.events.sia-inform-events'],
    events: event_occurrences,
    removeAgendaLink: removeAgendaLink
  }, {
    id: 'sia-events',
    title: event_labels['cms.newsletter.events.sia-events'],
    events: sia_events
  }, {
    id: 'external-events',
    title: event_labels['cms.newsletter.events.external-events'],
    events: external_events
  }];
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "events"
  }, eventCategories.map(category => category.events && category.events.length > 0 && /*#__PURE__*/_react.default.createElement("div", {
    key: category.id,
    id: category.id,
    className: "event-group sia-padding-03 sia-border-01-bottom sia-padding-05-bottom"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "title sia-text-08"
  }, category.title), category.events.map((el, index) => /*#__PURE__*/_react.default.createElement(EventItem, {
    event: el,
    key: index,
    category: category,
    lang: lang,
    newsletter_date: newsletter_date
  })), category.id == 'sia-inform-events' && !category.removeAgendaLink && /*#__PURE__*/_react.default.createElement("div", {
    className: "container sia-margin-02-top "
  }, /*#__PURE__*/_react.default.createElement(_DownloadLinkBox.default, {
    items: [{
      link: {
        original_url: agenda_url || `/agenda`,
        title: event_labels['cms.newsletter.events.agenda.link']
      }
    }],
    lang: lang,
    isCMS: false
  })))));
};
var _default = exports.default = Events;